import { stackDefaultStyles } from "../constants/constants";
import { createComponent } from "../createComponent";
const Stack = createComponent({
  acceptsClassName: true,
  defaultProps: {
    ...stackDefaultStyles,
    flexDirection: "column"
  }
});
export {
  Stack
};
//# sourceMappingURL=Stack.js.map
